import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toggleTabs } from "../../Screens/Redux/slice";
import PropTypes from "prop-types";
import { toggleButton } from "../../Screens/Redux/switchToggleSlice";
import { Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
function Tab({ isDisabled = false,isDisabledTab=false }) {
  // const [istoggle,setIsToggle] = useState()
  const tabs = useSelector((state) => state.Tabs.activeTab);
  // const istoggle = useSelector((state) => state.switchButton.activeSwitch);
  const dispatch = useDispatch();
  const { channelUrl , subChannel , mi_u} = useSelector(
    (state) => state.partnerChannelNameSlice.marutiUserDetails
  );

  console.log("isDisabledTab",isDisabledTab)
  return (
    <>
      {channelUrl === "maruti" ? (
        ""
      ) : (
        <div className="md:w-full">
          <ul className=" flex flex-row   w-full   text-sm font-medium text-center text-gray-500 dark:text-gray-400 gap-3 xs:text-red-500 cursor-pointer">
       { !isDisabledTab && 
            <li className="">
              <TabPill
                label={"PAN"}
                onClick={() => {
                  dispatch(toggleTabs("pan"));
                  dispatch(toggleButton(true));
                }}
                isActive={tabs === "pan"}
                disable={isDisabled}
                id={"panckyc"}
              />
              {/* <Tooltip id="button-report1" title="Report">
                <InfoIcon sx={{ color: "black", fontSize: "22px" }} />
              </Tooltip> */}
            </li>
       }

            <li className="">
              <TabPill
                label={"Aadhaar"}
                onClick={() => {
                  dispatch(toggleTabs("aadhaar"));
                  dispatch(toggleButton(true));
                }}
                isActive={tabs === "aadhaar"}
                disable={isDisabled}
                id={"aadhaarkyc"}
              />
              {/* <Tooltip id="button-report2" title="Report">
                <InfoIcon sx={{ color: "black", fontSize: "22px" }} />
              </Tooltip> */}
            </li>

            {!(subChannel === "web" && mi_u.slice(0, 3) === "KY3") &&  
              <li className="">
                <TabPill
                  label={"Other OVDs"}
                  onClick={() => {
                    dispatch(toggleTabs("otherDocs"));
                    dispatch(toggleButton(true));
                  }}
                  isActive={tabs === "otherDocs"}
                  disable={isDisabled}
                  id={"otherDocs"}
                />
              </li>
            }
          </ul>
        </div>
      )}
    </>
  );
}

export default Tab;
Tab.propTypes = {
  isDisabled: PropTypes.bool,
};

export const TabPill = ({
  label,
  onClick = () => {},
  isActive,
  disable = false,
  id,
  style = { padding: 3 },
  isInfoIcon = true,
}) => {
  const getStyle = () => {
    if (isActive) {
      return `inline-block  flex gap-[4px] h-full w-full p-${style?.padding} px-${style?.paddingLeftRight}  bg-white-600 border bg-[#FCE9E9] border-red-500 text-black rounded-lg  shadow-sm cursor-pointer`;
    }
    return `inline-block  flex gap-[4px] h-full w-full p-${style?.padding} px-${
      style?.paddingLeftRight
    } bg-white-600 text-gray-500 border rounded-lg shadow-md cursor-pointer ${
      disable ? "pointer-events-none" : ""
    }`;
  };
  const panToolTipString = "Data id fetched from CKYC using your Pan and Mobile.";
  const aadhaarToolTipString =
    // "Data id fetched from UIDAI using your Aadhaar number.";
    "Fetch data via digilocker to complete your KYC.";
  const ovdToolTipString = "Use other documents to submit your KYC";
    let labelValue =
      label === "Aadhaar"
        ? aadhaarToolTipString
        : label === "PAN"
        ? panToolTipString
        : ovdToolTipString;

  return (
    <div className={getStyle()} aria-current="page" onClick={onClick} id={id}>
      {label}
      {isInfoIcon && (
        <div className="flex">
          <Tooltip
            id="button-report1"
            title={labelValue}
            describeChild
            placement="top"
            arrow
          >
            <InfoIcon sx={{ color: "black", fontSize: "17px" }} />
          </Tooltip>
        </div>
      )}
    </div>
  );
};

export const CustomeTabPill = ({
  label,
  onClick = () => {},
  isActive,
  disable = false,
  id,
  style = { padding: 3 },
  description,
  image,
  customeStyle,
}) => {
  const getStyle = () => {
    if (isActive) {
      return `inline-block  flex gap-[4px] h-full w-full p-${style?.padding} px-${style?.paddingLeftRight}  bg-white-600 border bg-[#FCE9E9] border-red-500 text-black rounded-lg  shadow-sm cursor-pointer`;
    }
    return `inline-block  flex gap-[4px] h-full w-full p-${style?.padding} px-${
      style?.paddingLeftRight
    } bg-white-600 text-gray-500 border rounded-lg shadow-md cursor-pointer ${
      disable ? "pointer-events-none" : ""
    }`;
  };

  return (
    <div
      className={`h-auto  w-full shadow-md rounded-md flex items-center ${getStyle()} aria-current="page" cursor-pointer w-full mb-[16px] md:mb-0`}
      onClick={onClick}
    >
      <div className="p-4 ">
        <div className="flex justify-center mb-2">
          <img src={image} alt="img" style={customeStyle} />
        </div>
        <span className=" flex justify-center text-[#e94d51] font-bold mb-2 text-center">
          {label}
        </span>
        <p className="text-center" style={{ fontSize: "14px" }}>
          {description}
        </p>
      </div>
    </div>
  );
};
